import CustomerServiceTree from "./serviceTree/CustomerServiceTree";
import WizardModule from "../wizardmodule/WizardModule";

type Props = {
  disableFp?: boolean;
  fpConfig: any;
  onSetFpService: (customerChoice: string) => void;
  onSaveClick: () => void;
  showSaveButton: boolean;
  onToggleChildServices: (ids: string[], enabled: boolean) => void;
};

export default function CustomerServiceEdit({
  fpConfig,
  onSetFpService,
  onSaveClick,
  showSaveButton,
  onToggleChildServices
}: Props) {
  return (
    <WizardModule
      showSaveButton={showSaveButton}
      onSaveClick={onSaveClick}
      moduleTitle="Digitala tjänster"
      info="Här väljer du vilka digitala tjänster kunden ska ha tillgång till och kundens struktur för dokumentmappar. När du är klar med Digitala tjänster & dokument, klickar du på Nästa."
    >
      <CustomerServiceTree
        fpConfig={fpConfig}
        onSetFpService={onSetFpService}
        onToggleChildServices={onToggleChildServices}
      />
    </WizardModule>
  );
}
